import type { FaireThemeEntity } from "../../entity_types/theme";

export const island_scents_car_home: FaireThemeEntity = {
  token: "island-scents-car-home",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Island Scents (Car + Home)",
  description:
    "Hawaiian-inspired fragrances that extend the aloha vibe beyond your shop",
  bgColor: "#EDE0F5",
  tileBgColor: "#963e2b",
  productTokens: [
    "p_mw73mrzdn9",
    "p_444jhvjf56",
    "p_a8ahq4v9tp",
    "p_dr9s882d26",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
